function ContextData() {

  var self = this;
  self.fileUploadServiceRootUrl = null;
  self.maximumChunkSize = null;
  self.maximumConcurrentUploads = null;

  self.init = function (options) {
    self.fileUploadServiceRootUrl = options.fileUploadServiceRootUrl;
    self.maximumChunkSize = options.maximumChunkSize;
    self.maximumConcurrentUploads = options.maximumConcurrentUploads;
  };
}

export default new ContextData();
